<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRouterBackVisible="false" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoUmArticolo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Azienda</label>
                        <b-form-input v-model="filtroUmArticolo.codiceAzienda" type="search" id="nome" placeholder="Inserire Codice Azienda"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">U.M</label>
                        <b-form-input v-model="filtroUmArticolo.um" type="search" placeholder="Inserire Unità di Misura"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazioni-magazzino-articoli-um-list-component ref="cmpConfigurazioniMagazzinoArticoliUmList" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioniMagazzinoArticoliUmListComponent from "../components/ConfigurazioniMagazzinoArticoliUmListComponent.vue";
export default {
    name: "ConfigurazioniMagazzinoArticoliUmListPage",
    components: { SaPageLayout, ConfigurazioniMagazzinoArticoliUmListComponent },
    data() {
        return {
            dadefinire: null,
            filtroUmArticolo: {
                codiceAzienda: null,
                um: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "",
            linkConfigurazioni: "/configurazionemagazzino",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliUmList.loadDataUmArticoli();
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroUmArticolo"] = JSON.stringify(me.filtroUmArticolo);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroUmArticolo = { dadefinire: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroUmArticolo"] = JSON.stringify(me.filtroUmArticolo);
            me.loadData();
        },
        onClickNuovoUmArticolo() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliUmList.onNuovoUmArticolo();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroUmArticolo = filterData;
        },
    },
};
</script>
